import { borderBottom } from "@material-ui/system";

export default theme => ({
    rootClassName: {
        width: "100%"
    },
    calendarModal: {
        width: "50%"
    },
    calendarFont: {
        "& .WeekCalendar": { fontFamily: 'Roboto' }
    },
    
    '@global': {
        
        // 1. Forzar diseño de tabla fija para evitar descuadres
        '.rbc-agenda-view table.rbc-agenda-table': {
            tableLayout: 'fixed !important',
            width: '100% !important',
        },
        '.rbc-agenda-table thead tr th:first-child': {
            display: 'none !important',
        },
        // 2. OCULTAR CABECERA Y CELDA DE FECHA
        // Usamos los nombres de clase exactos de la librería
        '.rbc-agenda-view .rbc-agenda-date-header, .rbc-agenda-view .rbc-agenda-date-cell': {
            display: 'none !important',
            width: '0px !important',
            padding: '0px !important',
            visibility: 'hidden !important',
        },

        // 3. CONFIGURAR LA COLUMNA QUE SÍ QUEREMOS (la de Hora/Periodo)
        '.rbc-agenda-view .rbc-agenda-time-header': {
            width: '20% !important', // Dale un poco más de espacio
            textAlign: 'left !important',
            paddingLeft: '15px !important',
            borderBottom: '1px solid #DDD !important',
        },
        '.rbc-agenda-view .rbc-agenda-time-cell': {
            width: '20% !important',
            verticalAlign: 'middle !important',
            paddingLeft: '15px !important',
            fontWeight: 'bold',
            borderRight: '1px solid #e5e5e5 !important',
        },

        // 4. COLUMNA DE EVENTO
        '.rbc-agenda-view .rbc-agenda-event-cell': {
            width: '80% !important',
            overflow: 'hidden !important', // Evita que el contenido desborde la celda
            whiteSpace: 'normal !important', // Permite que el contenido se ajuste
        },
        '.rbc-agenda-event-cell .rbc-agenda-event-header': {
            // Esto ajusta la cabecera del "Evento" (donde pusimos "Usuario | Estado...")
            fontWeight: 'bold !important',
            color: '#555 !important',
            fontSize: '13px !important',
            letterSpacing: '0.5px'
        },
        '.rbc-agenda-view .rbc-agenda-event-header, .rbc-agenda-view .rbc-agenda-event-cell': {
            padding: '10px 15px !important', // Controlamos el padding nosotros mismos aquí
            verticalAlign: 'middle !important',
        },

        // 2. Asegurar que no haya bordes internos que empujen el contenido
        '.rbc-agenda-event-cell': {
            width: '65% !important',
        },

        // 3. Eliminar estilos por defecto del texto del header para que no interfiera con el grid
        '.rbc-agenda-event-header': {
            textAlign: 'left !important',
            fontSize: '14px',
            color: theme.palette.text.secondary,
        },
        
    }
});